export class UserResponseModel {


  public activationCode: string;
  public name: string;
  public lastName: string;
  public vkto: string;
  public email: string;
  public mob1: string;
  public mob2: string;
  public memo: string;
  public userName: string;

  public vktoGroup: number;

  public active: number;

  public userId: number;




}



// WEBPACK FOOTER //
// ./src/app/models/user-response.model.ts